<template>
  <div class="zendesk-contact" :class="appState.zendeskWidget.isVisible ? 'shown' : ''" @click="$event.stopPropagation()">
    <div class="whq-contact-info">
      <img :src="whqIcon" alt="Contact WarehouseQuote Operations Icon" class="mr-2" referrerpolicy="no-referrer"/>
      <div class="flex flex-column">
        <div class="font-bold">Contact WarehouseQuote Operations</div>
        <div class="mt-1 flex align-items-center"><i class="material-symbols-outlined mail mr-2 text-sm" /><a href="mailto:operations@warehousequote.com">operations@warehousequote.com</a></div>
        <div class="mt-1 flex align-items-center"><i class="material-symbols-outlined phone mr-2 text-sm" /><a href="tel:816-317-0706">816-317-0706</a></div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { inject } from "vue";
  import whqIcon from "@/images/whq-icon.png";
  const appState = inject("appState");
</script>

<style lang="scss" scoped>
  .zendesk-contact {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 4.5rem;
    background: #2f2f2f;
    color: #fff;
    opacity: 0;
    pointer-events: none;
    font-family: system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",Arial,sans-serif;
    font-size: 10px;
    @media(min-width: $breakpoint-sm) {
      font-size: 12px;
      right: 16px;
      bottom: 16px;
      width: 342px;
      height: calc(5.5rem + 8px);
      padding-top: 8px;
      border-radius: 0 0 8px 8px;
    }
    &.shown {
      opacity: 1;
      pointer-events: auto;
      transition: 0.6s opacity ease-in-out;
      transition-delay: 0.2s;
      z-index: 1;
    }
    .whq-contact-info {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.75rem 0 1rem 0;
      @media(min-width: $breakpoint-sm) {
        margin: 0.75rem 0 0.75rem 0;
      }
      > img {
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
        border: 2px solid var(--color-border);
        align-self: center;
        @media(min-width: $breakpoint-sm) {
          width: 3.5rem;
          height: 3.5rem;
        }
      }
      a {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
</style>